import moment from "moment";
import Vue from 'vue';
import { router } from '@/router';
import _ from "lodash";
import store from '@/store';
import CinemaService from "@/apiServices/CinemaService";
function initialState() {
    return {
        allCinemaList: []
    };
};
const state = initialState();

const mutations = {
    ON_RESET_CINEMA_STORE_STATE: (state, payload) => {
        // state = initialState();
        const s = initialState()
        Object.keys(s).forEach(key => {
            state[key] = s[key]
        })
    },
    ON_SET_ALL_CINEMA_LIST: (state, payload) => {
        state.allCinemaList = payload
    }
};

const actions = {
    onResetMovieStoreState: async ({
        dispatch, commit, state }, { ...payload }) => {
        await commit('ON_RESET_MOVIE_STORE_STATE');
    },
    onGetCinemaList: async ({ dispatch, commit, state }, payload) => {
        await commit('ON_SET_ALL_CINEMA_LIST', [])
        CinemaService.GetCinemas(payload)
            .then((response) => {
                const { data } = response
                commit('ON_SET_ALL_CINEMA_LIST', data)
            }).catch((err) => {
                console.log(err)
            })
            .finally(() => {
                //Stop Loader
            });
    },
    onGetCinemaByCode: async ({ dispatch, commit, state }, payload) => {
        await commit('ON_SET_ALL_CINEMA_LIST', [])
        CinemaService.GetCinemaByCode(payload)
            .then(response => {
                const { data } = response
                commit('ON_SET_ALL_CINEMA_LIST', data)
            }).catch((err) => {
                console.log(err)
            })
            .finally(() => {
                //Stop Loader
            });
    }
};

const getters = {
    getAllCinemaList: state => state.allCinemaList
};

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/CinemaStore.js